import React, { useMemo } from 'react';
import { Sparkles, BookOpen } from 'lucide-react';
import './SubjectPillNav.css';

export default function SubjectPillsNav({ 
  subjects = [], 
  activeSubjectId, 
  setActiveSubjectId, 
  colors = [] 
}) {
  // Sort or prioritize: regular first, foundation second, quests last
  const categorizedSubjects = useMemo(() => {
    const typeOrder = { regular: 1, foundation: 2, quests: 3 };
    return [...subjects].sort((a, b) => {
      const orderA = typeOrder[a.subjectType?.toLowerCase()] || 99;
      const orderB = typeOrder[b.subjectType?.toLowerCase()] || 99;
      return orderA - orderB;
    });
  }, [subjects]);

  return (
    <nav className="subject-pills-bar">
      {categorizedSubjects.map((subject, index) => {
        const isSelected = subject.id === activeSubjectId;
        const currentPillColor = colors[index % colors.length] || '#6366f1';
        const type = subject.subjectType?.toLowerCase() || 'regular';

        return (
          <button
            key={subject.id}
            type="button"
            className={`subject-nav-pill pill--${type} ${isSelected ? 'is-active' : ''}`}
            style={{
              '--pill-color': currentPillColor,
            }}
            onClick={() => setActiveSubjectId(subject.id)}
          >
            {/* Regular subjects use the signature colored dot */}
            {type === 'regular' && (
              <span 
                className="pill-dot" 
                style={{ backgroundColor: currentPillColor }} 
              />
            )}

            {/* Foundation subjects feature a subtle academic badge icon */}
            {type === 'foundation' && (
              <span className="pill-badge-icon">
                <BookOpen size={13} />
              </span>
            )}

            {/* Quests feature an arcade/adventure sparkle */}
            {type === 'quests' && (
              <span className="pill-badge-icon pill-badge-icon--quest">
                <Sparkles size={13} />
              </span>
            )}

            <span className="pill-label">{subject.name}</span>
          </button>
        );
      })}
    </nav>
  );
}